import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { UtilService } from './util.service';
import { Observable } from 'rxjs/Observable';
import { Buyer, fromBE, toBE } from '../model/Buyer';

@Injectable()
export class BuyerService {
  constructor(private http: HttpClient, private utilService: UtilService) {
  }

  search(term: string): Observable<Buyer[]> {
    const url = this.utilService.getApiUrl('buyer/search');

    const params = new HttpParams().set('term', term);

    return this.http.get(url, { params })
      .map(
        (response: any) => {
          if (response.status === 0) {
            return response.data.map(buyer => fromBE(buyer));
          } else {
            throw Observable.throw(response);
          }
        },
        (error: any) => {
          return error;
        },
      );
  }


  create(request: Buyer): Observable<Buyer> {
    const url = this.utilService.getApiUrl('buyer');

    return this.http.post(url, toBE(request))
      .map(
        (response: any) => {
          if (response.status === 0) {
            return fromBE(response.data);
          } else {
            throw Observable.throw(response);
          }
        },
        (error: any) => {
          return error;
        },
      );
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/buyer.service.ts